import * as tslib_1 from "tslib";
import { Component, Vue, Watch } from "vue-property-decorator";
import { QUESTION_TYPE_MAP } from "../constant";
let QuestionSearch = class QuestionSearch extends Vue {
    constructor() {
        super(...arguments);
        this.questionTypes = QUESTION_TYPE_MAP.map((type) => ({
            value: type.id,
            label: type.text
        }));
        this.options = [
            {
                value: -1,
                label: "全部题型"
            },
            ...this.questionTypes
        ];
        this.selected = -1;
        this.keyword = "";
    }
    handleKeywordChange(keyword) {
        this.$bus.$emit("change-keyword", keyword);
    }
    beforeDestroy() {
        this.$bus.$off("change-keyword");
    }
    search() {
        this.$bus.$emit("active-search", this.keyword);
    }
    handleSelect(type) {
        this.$bus.$emit("send-ques-type", type);
    }
};
tslib_1.__decorate([
    Watch('keyword')
], QuestionSearch.prototype, "handleKeywordChange", null);
QuestionSearch = tslib_1.__decorate([
    Component({
        name: "QuestionSearch",
    })
], QuestionSearch);
export default QuestionSearch;
